import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I sidehustled $180k and why it almost killed my business",
  "description": "",
  "published": "2018-12-31T00:00:00.000Z",
  "redirect_from": ["/blog/sidehustled-180k-almost-killed-my-business/swizec/8835"],
  "categories": "Business, Freelancing, Personal, Side Projects, Thoughts",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/12/year-in-postits.jpg",
        "alt": "My year in post-its"
      }}></img></p>
    <p>{`$180k on the side. Next to my regular startup salary. That's crazy. Absolutely bonkers. 🤯`}</p>
    <p>{`91 blogposts, 86 emails to subscribers, 155 YouTube videos, 317 Facebook Posts, 5996 Tweets, 3 in-person workshops, 3 online workshops, 1 large client, 2 small clients, 3 mini launches, 2 large launches, 2 conference talks, 3 conferences.`}</p>
    <p>{`No wonder I'm tired.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The mind recoils in horror, unable to communicate with the spinal column. Which is interesting because you can actually watch yourself behaving in this terrible way, but you can’t control it.`}</p>
    </blockquote>
    <p><em parentName="p">{`PS: Help me help you improve your career in 2019. Answer 3 questions 👉 `}<a parentName="em" {...{
          "href": "https://swizecteller.typeform.com/to/GQP8T6"
        }}>{`a quick poll`}</a></em></p>
    <p>{`Ambition. It's like a disease. It eats at you from the inside.`}</p>
    <p>{`Once you get a taste of success, success of your own, not your boss giving you a pat on the back and a raise, and not your teacher or your parents saying `}<em parentName="p">{`"Good job kiddo, we're proud"`}</em>{`, it's all over.`}</p>
    <p>{`I mean `}<em parentName="p">{`real`}</em>{` success. The kind where strangers think you've created something so valuable they're willing to part with their own cold hard cash to have it. `}<em parentName="p">{`That`}</em>{` success.`}</p>
    <p>{`Once you have that, you can't stop. You just can't. You want more. You press harder. Work harder. Chase bigger and bigger gains. You spend your life looking for that hit that feels as good, as exciting, as amazing, as the first $1,000 you made on your own.`}</p>
    <p>{`And that's how making $180,000 almost killed my business.`}</p>
    <lite-youtube {...{
      "videoid": "Q9WZtxRWieM",
      "videostartat": "0"
    }}></lite-youtube>
    <h2 {...{
      "id": "the-deal-to-end-deals"
    }}>{`The deal to end deals`}</h2>
    <p>{`In December 2017, the creator of Maven reached out to me. `}<em parentName="p">{`"Hey, I like your work with React and D3. We got a team here at Big Company that needs some help"`}</em>{`.`}</p>
    <p>{`Sure, I said, let's talk next year. I'm busy right now. `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/how-i-sidehustled-72167-last-year-and-what-i-wanna-do-next/swizec/8016"
      }}>{`December last year`}</a>{` was one of my best sidehustle months on record.`}</p>
    <p>{`We got to talking in January. Talked about what the team needed, how I might help, what the goals were … all the things you're supposed to do when prospecting a new consulting client. I used to freelance. I got this.`}</p>
    <p>{`Then it was time to send a proposal.`}</p>
    <p>{`I swallowed hard, doubled my number, and hit send. These big companies … you gotta charge what `}<em parentName="p">{`they`}</em>{` think is real money, not what you think.`}</p>
    <lite-youtube {...{
      "videoid": "k5wayr6tYzY",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Your skills are worth more to a bigger company. Company with billions in revenue? If you improve their stuff by a fraction of a fraction of a percent, you're creating millions in value.`}</p>
    <p><img parentName="p" {...{
        "src": "/8939e4fc04b35c2173741bcf98edb3e4/media-d3mlE7uhX8KFgEmY-giphy.gif",
        "alt": null
      }}></img></p>
    <p><em parentName="p">{`"Tell you what, we got some budget to burn. Why don't we send you `}{`\\`}{`\\`}{`\\`}{`$100,000, and you tell us when it runs out"`}</em></p>
    <p>{`😱`}</p>
    <p>{`WHAT!? YES, OF COURSE.`}</p>
    <p><em parentName="p">{`cough`}</em></p>
    <p>{`I mean, yes, of course. Let us shake hands like gentlemen. I will coach your team, and they will build this amazing thing for you.`}</p>
    <p>{`We started with a 2-day workshop on site. But they didn't have a room so we squeezed it into 1.5 days. ¯`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <lite-youtube {...{
      "videoid": "zzV2zVijqyA",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Then the real work began.`}</p>
    <p>{`Every Wednesday morning at 8am, we had a chat with the team. An hour on the phone, sometimes more. We talked about their struggles, and their code, and I developed little experiments to solve specific problems they had.`}</p>
    <p>{`You may have seen a lot of strange blog posts this year. Solutions to problems so specific everyone thought `}<em parentName="p">{`"Wtf why you write this?"`}</em>{`.`}</p>
    <p>{`That's why. It was for my special team.`}</p>
    <p>{`And it worked 👇`}</p>
    <blockquote>
      <p parentName="blockquote">{`you definitely provide a level of mentorship that nobody else here can provide`}</p>
      <p parentName="blockquote">{`you have gotten me past roadblocks which if you didn’t help unblock them… who knows where we would be right now. lol`}</p>
    </blockquote>
    <p>{`✌️`}</p>
    <h2 {...{
      "id": "excitement-runs-high"
    }}>{`Excitement runs high`}</h2>
    <p>{`So in April, I finally get this $100,000 cheque. Contracts, vendor systems, NET45 … my hands are shaking all the way to the bank.`}</p>
    <p>{`The teller looks at my cheque. Coughs a little. Swallows. Regains his composure. `}<em parentName="p">{`"Due to the size of this cheque and who it's from, it might take a few days to process"`}</em></p>
    <p>{`Totally fine by me! ✌️`}</p>
    <p>{`First major income into my brand new Swizec LLC. Formed it just for this. Well, for this and everything else. Sidehustle getting so big I didn't feel comfortable doing it under my name on PayPal.`}</p>
    <p>{`So I've got all this money … now what? What the hell do you do with a hundred thousand dollars!?`}</p>
    <p>{`I paid off 2016 taxes. Still owed $15k.`}</p>
    <p>{`I left $20k in the company as investment.`}</p>
    <p>{`I took $5k to pad my emergency fund, enjoy life with The Girl, and go on a fancy-ass Michelin star dinner. $450/person. It was amazing. 😋`}</p>
    <p>{`The rest, $60k, went into `}<a parentName="p" {...{
        "href": "https://www.wealthfront.com"
      }}>{`Wealthfront`}</a>{`. Don't know how to use it for my business (yet), might as well have it grow in some index funds, right?`}</p>
    <p>{`This was a mistake. We'll get to that.`}</p>
    <h2 {...{
      "id": "problems-at-the-day-job"
    }}>{`Problems at the day job`}</h2>
    <p>{`Around this time, my boss was like `}<em parentName="p">{`"Soooooo it feels like your heart isn't quite in the game anymore. It's like you're coming to work just to get some rest before you get back to your own stuff."`}</em></p>
    <p>{`Err…`}</p>
    <p><em parentName="p">{`"We might have to let you go, if you don't shape up"`}</em></p>
    <p>{`But my visa! My visa says I have to be employed by your company, or I have 10 days to leave the country.`}</p>
    <p><img parentName="p" {...{
        "src": "/479554c4f8a735776cf3ea265ea54f15/media-gtPaaCbkxpmWk-giphy.gif",
        "alt": null
      }}></img></p>
    <p><em parentName="p">{`"Yeah, so shape up, mate. We know you're working on a visa of your own and we support you in your endeavors. But if you're not useful to the company, we can't afford to be your nanny."`}</em></p>
    <p>{`He was right.`}</p>
    <p>{`I `}<em parentName="p">{`was`}</em>{` working on my own visa. The CEO even agreed to pay part of my lawyer fees because that shit's expensive and I started the process back in February. As soon as I knew about the Big Client. Before I knew when I'd get the money.`}</p>
    <p>{`Thanks, founder CEO dude. You're great. 🙏🏻`}</p>
    <p>{`No hard feelings between me and the founder. I think. He understood that when big opportunity comes knocking, a certain type of person can't help but answer.`}</p>
    <p>{`Hell, that's why he originally hired me.`}</p>
    <p>{`My boss, however, he's more traditional. Grew up in Amazon. Very top down. He saw my wandering and my sidehustling as a betrayal, I think.`}</p>
    <p>{`He wanted to groom me into a leader, and it was going so great for the first year or two. But the startup wasn't ready yet. It didn't need leaders. We had other shit to deal with.`}</p>
    <p>{`Then the startup started taking off. We made some breakthroughs. Got stuff working. Built some money-making pipelines.`}</p>
    <p>{`And this guy, he's been low-key working on being a leader … he just up and says, `}<em parentName="p">{`"Yo guys, I wanna focus on my own thing"`}</em></p>
    <p>{`Well, fuck that guy.`}</p>
    <p>{`My very first performance review ever (yes, after 3 years at the company, small startup okay) … it did not go great.`}</p>
    <p>{`Great engineer, sure, but all that "other" stuff we wanted from you but never said we wanted because you're supposed to just figure it out on your own as an ambitious person, you don't got that. None of it.`}</p>
    <p>{`I believe the CEO called it `}<em parentName="p">{`"Ambitious, but not ambitious within the company"`}</em>{`.`}</p>
    <h2 {...{
      "id": "life-gets-hard"
    }}>{`Life gets hard`}</h2>
    <p>{`So life was hard for many months.`}</p>
    <p>{`Working hard to prove my mettle at the day job, transitioning to being a contractor so we can focus on my engineering output, not on my "everything else" output. The boss was getting used to this also. 'Twas a big adjustment period for both of us.`}</p>
    <p>{`Outside work, I had this visa thing hanging over my head. Every few days, my lawyer would ask for something new. Some new piece of evidence. A new business plan. Something.`}</p>
    <p>{`Time and again, I thought, `}<em parentName="p">{`"Ok this is it, we're submitting next week"`}</em>{` and get excited, only to be met with one more request.`}</p>
    <p>{`When finally we did submit, there was an RFE, request for evidence. The whole thing went back in the grinder for one more go.`}</p>
    <p>{`Huge weight on my mind. Started thinking it wasn't even worth it anymore. Maybe I'll just quit my job, go back to Europe, and say fuck it to all this Silicon Valley nonsenses. Europe ain't so bad.`}</p>
    <h2 {...{
      "id": "existing-products-take-a-back-seat"
    }}>{`Existing products take a back seat`}</h2>
    <p>{`While all this is happening, I still have that ambition monkey on my back.`}</p>
    <p><img parentName="p" {...{
        "src": "/d76d9b92d8c35805ddf631783a153c34/media-E5buNvhM8Y5Y4-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`There's $100,000 in the bank just staring at me. Telling me I got a golden ticket and why am I wasting this beautiful opportunity?`}</p>
    <p>{`Even my CEO was all like `}<em parentName="p">{`"Dude, you're being way too cautious. Now's the time to push."`}</em></p>
    <p>{`Well, for starters, I'm not allowed to use that money for anything other than business expenses. Visa stuff.`}</p>
    <p>{`And I gotta pay San Francisco rent.`}</p>
    <p>{`Even when I do get my own visa … can I support myself on lumpy revenue? Did I just get lucky? Can I pull this off again? Heck if I know …`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/12/monthly-revenue.png",
        "alt": "Monthly revenue graph"
      }}></img></p>
    <p>{`That is not a confidence inspiring graph. You can't pay rent on a graph like that.`}</p>
    <h3 {...{
      "id": "learn-while-you-poop"
    }}>{`Learn While You Poop`}</h3>
    <p>{`So in April, I came up with Learn While You Poop. A subscription service with bite-sized daily content.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`LEARN WHILE YOU POOP: Why you should learn React 🧐`}<br parentName="p"></br><br parentName="p"></br>{`Hi 👋 I’m trying something new and need your feedback. What do you think of this as a format for a daily 2min video?`}<br parentName="p"></br><br parentName="p"></br>{`No pressure learning at 2 minutes per day.Start with WHY React all the way to a React 16.3 master in a month. `}<a parentName="p" {...{
          "href": "https://t.co/g5bmXdep0g"
        }}>{`pic.twitter.com/g5bmXdep0g`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/981932124231024640"
      }}>{`April 5, 2018`}</a></blockquote>
    <p>{`2 minute videos every day. Subscribe to get article breakdowns for in-depth learning.`}</p>
    <p>{`The concept worked great. Social media loved it. A short video every day straight from the bathroom? Fun! Amazing! Wow.`}</p>
    <p>{`The views rolled in. The tweets got shared. People put me in newsletters. It was great.`}</p>
    <p>{`But few were buying. At peak, I had 7 active subscribers. Conversion rate as high as 9% once people saw the buy button, churn rates pretty okay, but no traffic to the landing page.`}</p>
    <p>{`According to a SaaS calculator, Learn While You Poop would make around $12,000/month before it taps out. If I could get the traffic.`}</p>
    <p>{`But Learn While You Poop had a problem: It wasn't good enough.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I think this is the trap that Learn While You Poop fell into. Still figuring out howto fix `}<a parentName="p" {...{
          "href": "https://t.co/k3nzgSU3sS"
        }}>{`pic.twitter.com/k3nzgSU3sS`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1035603419648516096"
      }}>{`August 31, 2018`}</a></blockquote>
    <p>{`I just didn't have the energy to do it justice.`}</p>
    <p>{`With all the shit going on in my life, making daily videos was a miserable experience. I was snappy, I was tired, I was cranky. I never got around to writing any of those articles.`}</p>
    <p>{`Videos are still out there, and they're great. But the bathroom gimmick only goes so far. I'd have to expand. I still might.`}</p>
    <h3 {...{
      "id": "react--d3v4-stagnates"
    }}>{`React + D3v4 stagnates`}</h3>
    <p>{`Meanwhile, my flagship product, `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js/"
      }}>{`React + D3v4`}</a>{`, the one that got me so far in life, was stagnating.`}</p>
    <p>{`Withering away with marketing funnels shut off for repairs and never repaired. Dying with ideas of improvements that never got implemented.`}</p>
    <p>{`If your landing page traffic falls by half, your revenue falls by half too.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`This is a fascinating graph of what happens when you get distracted in business. `}<br parentName="p"></br><br parentName="p"></br>{`50% less traffic on a landing page directly leads to 50% less revenue. I always knew this intuitively but to be faced with it point blank like this is wow. `}<a parentName="p" {...{
          "href": "https://t.co/C7UgY4N3jv"
        }}>{`pic.twitter.com/C7UgY4N3jv`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1075276171280072709"
      }}>{`December 19, 2018`}</a></blockquote>
    <p>{`Obvious, but panic inducing also.`}</p>
    <h2 {...{
      "id": "shit-i-gotta-make-cashflow"
    }}>{`Shit, I gotta make cashflow`}</h2>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/sponsored-genius-visa/swizec/8612"
      }}>{`September comes, and I get my visa`}</a>{`.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`🎉🎉 OMFG IT WORKED!!! O-1 Visa now sponsored by my own Swizec LLC 🎉🎉`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1038124110180544512"
      }}>{`September 7, 2018`}</a></blockquote>
    <p>{`I become a contractor at the day job and switch to 4 days/week. Gonna have more time for my own stuff.`}</p>
    <p>{`Just like that, $2000/month slashed from my salary. Taxes no longer deducted, so the same amount comes into my bank account as before. But I learned my lesson about taxes last year when `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/how-i-got-boned-by-taxes-two-years-in-a-row/swizec/7582"
      }}>{`I got boned by taxes 2 years in a row`}</a>{`.`}</p>
    <p>{`Not about to repeat that mistake again. No sir-e.`}</p>
    <p>{`It's okay, I got this.`}</p>
    <p>{`And then the stock market starts crashing.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/12/stock-market.png",
        "alt": "Bye bye returns"
      }}></img></p>
    <p>{`This is relevant because remember that money I put away in Act 1 so it can grow while I figure out what to use it for? That money is losing value. Fast.`}</p>
    <p>{`Take money from index funds, and I lock-in the losses. Some $15,000 vanishes over night, and I never get it back. No, that money has to stay there until the market recovers.`}</p>
    <p>{`We gotta do this on cashflow alone.`}</p>
    <p>{`Oh, and the Big Client? Their $100k piggybank ran out in August, and they agreed to renew for another $100k. Fuck yeah.`}</p>
    <p>{`Until the market crashed.`}</p>
    <p>{`Now it's more like `}<em parentName="p">{`"Yeah so we wanna build this team internally, and we don't have the budget for you anymore. How much do we owe past piggybank?"`}</em></p>
    <p>{`That's fair. Exactly what my CEO said would happen way back in January. Dude knows his markets and how big companies operate.`}</p>
    <p>{`Big Client agrees to pay for the extra 3 months of consulting I helped them with. But that's NET45 away, and NET45 came on Christmas, so yeah, I'm still waiting. Gonna ping them in the new year. Fingers crossed. 🤞`}</p>
    <p>{`Gonna cover my credit card bill 😅`}</p>
    <h2 {...{
      "id": "push-comes-to-shove"
    }}>{`Push comes to shove`}</h2>
    <p>{`So here I am with my back to the wall.`}</p>
    <p>{`Cashflow dropped, subscriptions not picking up, React+D3v4 neglected all year so that's barely making any money, can't use the money I got due to market conditions.`}</p>
    <p>{`At the same time, my burn is through the roof. Never been so high ever before.`}</p>
    <p>{`I just bought a motorcycle because I `}<em parentName="p">{`really`}</em>{` needed something to keep my spirits up. (it worked)`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Best way to plan the new year `}<a parentName="p" {...{
          "href": "https://t.co/3KKreDGLLm"
        }}>{`pic.twitter.com/3KKreDGLLm`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1078754200857673728"
      }}>{`December 28, 2018`}</a></blockquote>
    <p>{`And I hired engineers back in May or June.`}</p>
    <p>{`There was no way I could pull off building Learn While You Poop on my own while also pushing hard at the day job. So I hired some help.`}</p>
    <p>{`It worked.`}</p>
    <p>{`I pulled back from the brink of burnout disaster, created a bunch of content, and learned a lot about structuring things into bite-sized pieces so customers can actually learn from me. The bite-sized approach really works.`}</p>
    <p>{`But now I gotta pay all these people. 4 freelancers in total who need both work and money every month. Plus all of a sudden, the LLC has to pay me, too.`}</p>
    <p>{`Fuck.`}</p>
    <p>{`Ok, back to basics. What do we know works? React for Data Visualization. Let's launch an update.`}</p>
    <p>{`People have been asking for one for months. The dataviz director at Visa `}<em parentName="p">{`emailed me`}</em>{` for frick's sake. Gently nudged me with a `}<em parentName="p">{`"Hey, you should update this.”`}</em></p>
    <p>{`In August, I launched a preorder. No work done yet. Just an experiment. Sent it to my list of emails, asked one of my engineers to start building a landing page.`}</p>
    <p>{`We made $8967.`}</p>
    <p>{`Okay, okay, there's something there. Maybe this product isn't as dead as I thought it was.`}</p>
    <p>{`Work hard on the updates. A little every day. Run 3 or 4 online workshops to develop the video material.`}</p>
    <p>{`By end of October, the book was updated. But the PDF format no longer did it justice. I pivot to a full-on course.`}</p>
    <p>{`We move to Teachable. My engineers build some hacks so we can import markdown without dealing with Teachable's editor.`}</p>
    <p>{`Around Thanksgiving, another launch. $7000. Half of it comes in January because Teachable is weird like that.`}</p>
    <p>{`I'm editing videos as fast as I can. No time to fill the wonderful landing page with good copy. Still waiting on that. Still struggling with the videos.`}</p>
    <p>{`Seriously, editing 8 hours of video into bite-sized pieces is hard. Harder than I ever thought possible.`}</p>
    <h2 {...{
      "id": "whats-next"
    }}>{`What's next?`}</h2>
    <p>{`It's December 31st, and I can see the light at the end of the tunnel. React for Data Visualization is almost done.`}</p>
    <p>{`Videos are almost ready. Landing page waiting for my copy. I think I know what that copy is going to be.`}</p>
    <p>{`Then we can focus on rebuilding those marketing funnels. Do more marketing, and if my calculations are right, we need just 3000 visitors per month to make $100,000 in 2019 sales.`}</p>
    <p>{`And I want to launch 2 more products. Just two.`}</p>
    <p>{`I think I know how.`}</p>
    <p>{`This year was tough, but it taught me a lot about developing, building, and then launching products. A pipeline, if you will.`}</p>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://swizecteller.typeform.com/to/GQP8T6"
      }}>{`help me help you in your career with this poll`}</a>{`.`}</p>
    <p>{`👉 `}<a parentName="p" {...{
        "href": "https://swizecteller.typeform.com/to/GQP8T6"
      }}>{`click me`}</a></p>
    <p>{`That's the theme for 2019.`}</p>
    <p>{`No more hustling. No more heroic efforts. Systems and processes and pipelines. Hustling got me this far, but it won't get me to the next level.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/12/trajectory.png",
        "alt": null
      }}></img></p>
    <p>{`That's the trajectory I want to maintain. 🤘`}</p>
    <h2 {...{
      "id": "stats-and-breakdowns-for-the-curious"
    }}>{`Stats and breakdowns for the curious`}</h2>
    <p>{`Realized Revenue: $145,490`}</p>
    <p>{`Booked Revenue: $180,451`}</p>
    <p>{`Expenses: $55,527`}</p>
    <h3 {...{
      "id": "money-in-breakdown"
    }}>{`Money-in breakdown:`}</h3>
    <p>{`Consulting: $102,500`}</p>
    <p>{`Workshops: $14,377`}</p>
    <p>{`React for Data Viz: $10,939`}</p>
    <p>{`React + D3v4: $8,865`}</p>
    <p>{`Patreon: $1305`}</p>
    <p>{`Packt Royalties: $1623`}</p>
    <p>{`Coaching: $1500`}</p>
    <p>{`LearnWhileYouPoop: $938`}</p>
    <p>{`ES6 Cheatsheet: $220`}</p>
    <h3 {...{
      "id": "was-it-worth-it"
    }}>{`Was it worth it?`}</h3>
    <p>{`1212 hours sidehustle`}</p>
    <p>{`23 hours / week`}</p>
    <p>{`3 hours / day`}</p>
    <p>{`$148/hour before expenses and taxes`}</p>
    <p>{`$103/hour after expenses`}</p>
    <p><em parentName="p">{`If the outstanding money ever comes`}</em>{` 🧐`}</p>
    <h3 {...{
      "id": "the-hustle"
    }}>{`The hustle`}</h3>
    <h4 {...{
      "id": "blog"
    }}>{`Blog`}</h4>
    <p>{`Blogposts: 91`}</p>
    <p>{`Blog traffic: 362,000 uniques ... 430,000 sessions`}</p>
    <h4 {...{
      "id": "email"
    }}>{`Email`}</h4>
    <p>{`Emails sent: 86`}</p>
    <p>{`Email subs: 2698 new for total 10,051`}</p>
    <p>{`(1440 unsubs)`}</p>
    <p>{`Avg. Rating: 4.7 stars`}</p>
    <p>{`Would recommend: 82%`}</p>
    <h4 {...{
      "id": "youtube"
    }}>{`YouTube`}</h4>
    <p>{`YouTube videos: 155`}</p>
    <p>{`YouTube traffic: 110,700 views ... 264,000 minutes`}</p>
    <p>{`YouTube subs: 1100 new for total 1816`}</p>
    <h4 {...{
      "id": "twitter"
    }}>{`Twitter`}</h4>
    <p>{`Tweets: 5996`}</p>
    <p>{`Impressions: 6,725,453`}</p>
    <p>{`Media views: 203,266`}</p>
    <p>{`Engagements: 208,629`}</p>
    <p>{`Follows: 64 😂`}</p>
    <h4 {...{
      "id": "facebook"
    }}>{`Facebook`}</h4>
    <p>{`FB posts: 317`}</p>
    <p>{`FB followers: 1203 new for total 3960`}</p>
    <hr></hr>
    <p>{`Thanks for coming along for the ride. You're the best :)`}</p>
    <p>{`Happy new year`}</p>
    <p>{`Cheers,`}</p>
    <p>{`~Swizec`}</p>
    <p>{`PS: No, really, `}<a parentName="p" {...{
        "href": "https://swizecteller.typeform.com/to/GQP8T6"
      }}>{`answer these 3 questions please`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      